import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { VmafError } from '../../api/ErrorNormalizer';
import { IVideoOutput } from './types';

const storeVideoMetaSessionId = createStandardAction(
  'VIDEO_META/STORE/SESSION_ID',
)<number>();

const storeVideoMetaId = createStandardAction(
  'VIDEO_META/STORE/VIDEO_ID',
)<string>();

const storeVideoMetaProgressId = createStandardAction(
  'VIDEO_META/STORE/PROGRESS_ID',
)<string>();

const requestVideoOutput = createAsyncAction(
  'VIDEO_OUTPUT/REQUEST',
  'VIDEO_OUTPUT/SUCCESS',
  'VIDEO_OUTPUT/FAILURE',
)<number, IVideoOutput, VmafError>();

const setVideoOutputNeedRetry = createStandardAction(
  'VIDEO_OUTPUT/NEED_RETRY',
)();

export {
  requestVideoOutput,
  setVideoOutputNeedRetry,
  storeVideoMetaSessionId,
  storeVideoMetaId,
  storeVideoMetaProgressId,
};
